import React, { useState } from "react";
import { Link } from "react-router-dom";
import CompanyDropdown from "./CompanyDropdown";

// Accept the onLinkClick prop to close the mobile menu on navigation
const NavLinks = ({ isMobile = false, onLinkClick = () => {} }) => {
  const [isCompanyDropdownVisible, setCompanyDropdownVisible] = useState(false);

  // Unified click handler for toggling the dropdown on both mobile and desktop
  const handleCompanyClick = (e) => {
    // Prevents the link from navigating to allow the dropdown to toggle
    e.preventDefault();
    setCompanyDropdownVisible(!isCompanyDropdownVisible);
  };

  // A handler that ensures the main mobile menu and the dropdown close when a dropdown link is clicked
  const handleDropdownLinkClick = () => {
    onLinkClick(); // Close mobile sidebar
    setCompanyDropdownVisible(false); // Close the company dropdown
  };

  return (
    <div className={isMobile ? "sidebar-nav-links" : "desktop-nav-links"}>
      {/* Apply onLinkClick to top-level navigation items */}
      <Link to="/customers" className="nav-item" onClick={onLinkClick}>
        Customers
      </Link>

      <Link to="/pricing" className="nav-item" onClick={onLinkClick}>
        Pricing
      </Link>

      <div
        className="nav-item-wrapper"
        // Removed onMouseEnter and onMouseLeave to disable hover functionality
      >
        <Link to="#" className="nav-item" onClick={handleCompanyClick}>
          <span>Company</span>
          {/* The dropdown arrow is now visible on both mobile and desktop */}
          <svg
            className={`dropdown-arrow ${
              isCompanyDropdownVisible ? "open" : ""
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </Link>
        {isCompanyDropdownVisible && (
          // Pass the updated click handler to the dropdown component
          <CompanyDropdown onLinkClick={handleDropdownLinkClick} />
        )}
      </div>
    </div>
  );
};

export default NavLinks;